import image1 from '@/assets/images/news/detail/20201128/1.jpg';
import image2 from '@/assets/images/news/detail/20201128/2.jpg';
import image3 from '@/assets/images/news/detail/20201128/3.png';
import image4 from '@/assets/images/news/detail/20201128/4.jpg';
import image5 from '@/assets/images/news/detail/20201128/5.jpg';
import image6 from '@/assets/images/news/detail/20201128/6.jpg';
import image7 from '@/assets/images/news/detail/20201128/7.png';

export default {
  id: '20201128', //  模块 id
  title: '成都雄起！西南地区，我们来了！', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text: '和我在成都的街头走一走 喔…',
      isIndent: false,
    },
    {
      type: 0,
      text: '直到所有的灯都熄灭了也不停留',
      isIndent: false,
    },
    {
      type: 0,
      text: '走到玉林路的尽头',
      isIndent: false,
    },
    {
      type: 0,
      text: '坐在小酒馆的门口',
      isIndent: false,
    },
    {
      type: 0,
      text: '...',
      isIndent: false,
    },
    {
      type: 0,
      text: '中国人特有的宽容是——“来都来了”',
      isIndent: false,
    },
    {
      type: 0,
      text: '而这份宽容在成都绝无用武之地',
      isIndent: false,
    },
    {
      type: 0,
      text: '鲜香麻辣的火锅、安逸好耍的麻将、憨态可掬的熊猫',
      isIndent: false,
    },
    {
      type: 0,
      text: '哪一样都是大杀器',
      isIndent: false,
    },
    {
      type: 0,
      text: '直让人“来了就不想走”',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1, image2],
    },
    {
      type: 0,
      text:
        '经过2个月紧锣密鼓的准备，2020年11月28日，叮咚买菜成都事业部正式开业，扬帆起航。叮咚买菜在生鲜电商领域，践行着“绝不把不好的菜卖给用户”的价值观，快速发展，一路高歌。以上海为根据地，辐射江浙沪皖，布局北上广深。今天，叮咚买菜为梦出征，西进蓉城，为成都人民的优质生活，提供贴心的服务。',
      isIndent: false,
    },
    {
      type: 1,
      title: ['《赢战蓉城 叮咚雄起》成都开城筹备记'],
      isQrcode: true,
      src: [image3],
    },
    {
      type: 0,
      text:
        '早晨迎着初升的太阳，成都的叮咚家人们紧锣密鼓的准备开业典礼。此刻，怀着无限憧憬与期待，叮咚的“萝卜”正式扎根于西南片区。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image4, image5],
    },
    {
      type: 0,
      text:
        '开城筹备期间离不开各部门的紧密协作，大家齐心协力，攻坚克难，发扬我们炮火猛、反应快的工作作风，同目标、共进退，打胜仗。',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image6],
    },
    {
      type: 0,
      text:
        '未来，我们坚信叮咚有我会更好！我们将一起和时间赛跑，为民生加油！用“自来水模式”来服务成都的千家万户，与蓉城、共美好！',
      isIndent: false,
    },
    {
      type: 1,
      title: ['码上观看《叮咚买菜 成都事业部》开业盛况'],
      isQrcode: true,
      src: [image7],
    },
  ],
};
